import { useMutation, useQueryClient } from '@tanstack/react-query';
import { prefillReviewApi, prefillReviewKeys } from '@client/api/waterlily';
import { useToast } from '@client/components/hooks/use-toast';

export function useCompletePrefillReview(formReferenceId: string | undefined) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: () => {
      if (!formReferenceId) {
        throw new Error('Form reference ID is required');
      }
      return prefillReviewApi.complete(formReferenceId);
    },
    onSuccess: () => {
      if (formReferenceId) {
        queryClient.invalidateQueries({ queryKey: prefillReviewKeys.detail(formReferenceId) });
      }
    },
    onError: () => {
      toast({
        title: 'Something went wrong',
        description: 'We could not save your review. Please try again.',
        variant: 'destructive',
        duration: 8000,
      });
    },
  });
}
